module.exports = __webpack_public_path__ + "img/add-person_white.32c36878.svg";